document.addEventListener("DOMContentLoaded", function () {
	const track = document.querySelector(".scrolling-logos__track");
	if (!track) return;

	const images = track.querySelectorAll("img");

	function initScrollingLogos() {
		// Clone the logo set for seamless infinite scroll
		const clone = track.innerHTML;
		track.innerHTML += clone;

		// Set animation duration based on track width for consistent speed
		const PIXELS_PER_SECOND = 50;
		const halfWidth = track.scrollWidth / 2;
		const duration = halfWidth / PIXELS_PER_SECOND;
		track.style.animationDuration = duration + "s";

		// Pause on hover using CSS class (Safari-safe)
		const slider = document.querySelector(".scrolling-logos__slider");
		if (slider) {
			slider.addEventListener("mouseenter", () => {
				track.classList.add("is-paused");
			});
			slider.addEventListener("mouseleave", () => {
				track.classList.remove("is-paused");
			});
		}
	}

	// Wait for all logo images to load before cloning
	// This ensures correct track width for the -50% translation
	if (images.length === 0) {
		initScrollingLogos();
		return;
	}

	let loadedCount = 0;
	const totalImages = images.length;

	function onImageReady() {
		loadedCount++;
		if (loadedCount >= totalImages) {
			initScrollingLogos();
		}
	}

	images.forEach((img) => {
		if (img.complete) {
			onImageReady();
		} else {
			img.addEventListener("load", onImageReady);
			img.addEventListener("error", onImageReady);
		}
	});
});
